export class BaseData {

    public title: string;
    public subtitle: string;
    public icon: string;
    public tooltipDescription: string;

    constructor(baseData: any = {}) {
        this.title = baseData.title || '';
        this.subtitle = baseData.subtitle || '';
        this.icon = baseData.icon || '';
        this.tooltipDescription = baseData.tooltipDescription || '';
    }

    get type() {
        return 'baseData';
    }

}
